export default {
  setdaysToDate (state: {[key:string]: number}, val: number) {
    state.daysToDate = val
  },
  setDisplayYear (state: any, year: string) {
    state.displayYear = year
  },
  setStageListModalFlag (state: {[key: string]: any}, flag: boolean) {
    state.stageListModalFlag = flag
  },
  setImgDate (state: any, date: number) {
    state.imgDate = date
  },
  setMainImgId (state: any, id: number) {
    state.imgId = id
  },
  setMaxDate (state: any, date: string) {
    state.maxDate = date
  },
  setStageData (state: any, data: {[key: string]: any}) {
    state.stageData = data
  }
}
